import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export type TrialRateSelectCompanyPopupState = {
    isTrialRateSelectCompanyPopupOpen: boolean;
};

const initialState: TrialRateSelectCompanyPopupState = {
    isTrialRateSelectCompanyPopupOpen: false,
};

export const trialRateSelectCompanyPopupSlice = createSlice({
    name: 'trialRateSelectCompanyPopup',
    initialState,
    reducers: {
        setTrialRateSelectCompanyPopupOpen: (
            state,
            action: PayloadAction<boolean>,
        ) => {
            state.isTrialRateSelectCompanyPopupOpen = action.payload;
        },
    },
});

export const {
    setTrialRateSelectCompanyPopupOpen,
} = trialRateSelectCompanyPopupSlice.actions;

export default trialRateSelectCompanyPopupSlice.reducer;
